import {
	CognitoUserPool,
	AuthenticationDetails,
	CognitoUser,
	CognitoRefreshToken
} from 'amazon-cognito-identity-js'
import jsonwebtoken from 'jsonwebtoken'
import router from '@/router.js'
import store from '@/store/store'

//prod
export const poolData = {
	UserPoolId: 'ap-southeast-2_efKjphPnz', // Your user pool id here
	ClientId: '70hargfvu1c1ebklldnbj3u7g9' // Your client id here
}

export default {
	login(username, password, newPassword, attributesData) {
		const userPool = new CognitoUserPool(poolData)

		const authenticationDetails = new AuthenticationDetails({
			Username: username,
			Password: password
		})
		var userData = {
			Username: username,
			Pool: userPool
		}
		var cognitoUser = new CognitoUser(userData)

		return new Promise(function(resolve, reject) {
			cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: function(result) {
					console.log('success')
					const token = result.getIdToken().getJwtToken()
					const refreshToken = result.getRefreshToken().getToken()
					const jwtdecoded = jsonwebtoken.decode(token)
					const name = jwtdecoded.name
					const profile = jwtdecoded.profile
					const email = jwtdecoded.email
					const companyName = jwtdecoded['custom:company_name']
					const contactNumber = jwtdecoded['custom:contact_number']
					const expireTime = jwtdecoded.exp
					const user = {
						profile,
						email,
						name,
						companyName,
						contactNumber
					}

					console.log(token)
					sessionStorage.setItem('refreshToken', refreshToken)
					sessionStorage.setItem('token', token)
					sessionStorage.setItem('user', JSON.stringify(user))

					resolve({
						token,
						refreshToken,
						user,
						expireTime
					})
				},
				onFailure: function(err) {
					console.log('failure')
					console.log(err)
					if (err.code === 'UserNotConfirmedException') {
						cognitoUser.resendConfirmationCode(function(
							err,
							result
						) {
							if (err) {
								console.log(err)
							}
						})
					}
					const notification = {
						type: 'error',
						message: err.message
					}
					store.dispatch('notification/add', notification, {
						root: true
					})
					reject(err)
				},
				newPasswordRequired: function(
					userAttributes,
					requiredAttributes
				) {
					console.log(userAttributes, requiredAttributes)
					if (newPassword && attributesData) {
						cognitoUser.completeNewPasswordChallenge(
							newPassword,
							attributesData,
							this
						)
					} else {
						const notification = {
							type: 'error',
							message: 'Need create new password'
						}
						store.dispatch('notification/add', notification, {
							root: true
						})
						reject({ code: 'needCreateNewPassword' })
					}
				}
			})
		})
	},
	confirmingUser(username, password, verificationCode) {
		const userPool = new CognitoUserPool(poolData)

		const authenticationDetails = new AuthenticationDetails({
			Username: username,
			Password: password
		})
		var userData = {
			Username: username,
			Pool: userPool
		}
		var cognitoUser = new CognitoUser(userData)

		return new Promise(function(resolve, reject) {
			cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: function(result) {
					console.log('success')
				},
				onFailure: function(err) {
					console.log(err)
					cognitoUser.confirmRegistration(
						verificationCode,
						true,
						function(err, result) {
							if (err) {
								const notification = {
									type: 'error',
									message: err.message
								}
								store.dispatch(
									'notification/add',
									notification,
									{
										root: true
									}
								)
								reject(err)
							}
							resolve(result)
						}
					)
				}
			})
		})
	},
	resendConfirmationCode(username, password) {
		const userPool = new CognitoUserPool(poolData)

		const authenticationDetails = new AuthenticationDetails({
			Username: username,
			Password: password
		})
		var userData = {
			Username: username,
			Pool: userPool
		}
		var cognitoUser = new CognitoUser(userData)

		return new Promise(function(resolve, reject) {
			cognitoUser.authenticateUser(authenticationDetails, {
				onSuccess: function(result) {
					console.log('success')
				},
				onFailure: function(err) {
					cognitoUser.resendConfirmationCode(function(err, result) {
						if (err) {
							const notification = {
								type: 'error',
								message: err.message
							}
							store.dispatch('notification/add', notification, {
								root: true
							})
						}
					})
				}
			})
		})
	},
	forgetYourPassword(username, verificationCode, newPassword) {
		var userPool = new CognitoUserPool(poolData)

		var userData = {
			Username: username,
			Pool: userPool
		}

		var cognitoUser = new CognitoUser(userData)

		return new Promise((resolve, reject) => {
			console.log('promise')
			cognitoUser.forgotPassword({
				onSuccess: function(result) {
					router.push({
						name: 'login'
					})
				},
				onFailure: function(err) {
					console.log('on', err)
					// alert(err.message)
					const notification = {
						type: 'error',
						message: err.message
					}
					store.dispatch('notification/add', notification, {
						root: true
					})
					// reject(err)
					// const errMsg = err.message
					// router.push({
					// 	name: 'forgot-password',
					// 	query: { errMsg }
					// })
				},
				inputVerificationCode() {
					resolve((verificationCode, newPassword) => {
						cognitoUser.confirmPassword(
							verificationCode,
							newPassword,
							this
						)
					})
				}
			})
		})
	},
	changeAttribute(username, password) {
		const userPool = new CognitoUserPool(poolData)

		const authenticationDetails = new AuthenticationDetails({
			Username: username,
			Password: password
		})

		var userData = {
			Username: username,
			Pool: userPool
		}
		var cognitoUser = new CognitoUser(userData)

		var attributeList = []
		// attributeList.push(
		// 	new CognitoUserAttribute({
		// 		Name: 'profile',
		// 		Value: 'Staff'
		// 	})
		// )

		cognitoUser.authenticateUser(authenticationDetails, {
			onSuccess: function(result) {
				cognitoUser.updateAttributes(attributeList, function(
					err,
					result
				) {
					if (err) {
						console.log(err)
						return
					}
					console.log('call result: ' + result)
				})
			},
			onFailure: function(err) {
				console.log(err)
			}
		})
	},
	renew() {
		const user = JSON.parse(sessionStorage.getItem('user'))
		const username = user.email
		const refreshToken = sessionStorage.getItem('refreshToken')
		const RefreshToken = new CognitoRefreshToken({
			RefreshToken: refreshToken
		})

		const userPool = new CognitoUserPool(poolData)

		const userData = {
			Username: username,
			Pool: userPool
		}

		const cognitoUser = new CognitoUser(userData)

		return new Promise(function(resolve, reject) {
			cognitoUser.refreshSession(RefreshToken, (err, session) => {
				if (err) {
					const notification = {
						type: 'error',
						message: `Oops! Something went wrong.`
					}
					store.dispatch('notification/add', notification, {
						root: true
					})
					router.push({
						name: 'login'
					})
					// reject(err)
				} else {
					const newIdToken = session.idToken.jwtToken
					const newRefreshToken = session.refreshToken.token
					sessionStorage.setItem('refreshToken', newRefreshToken)
					sessionStorage.setItem('token', newIdToken)
					resolve({
						newIdToken,
						newRefreshToken
					})
				}
			})
		})
	},

	async checkTokenExpire() {
		const token = sessionStorage.getItem('token')
		const jwtdecoded = jsonwebtoken.decode(token)
		const expireTime = jwtdecoded.exp * 1000
		const currentTime = Date.now()
		console.log(expireTime < currentTime)
		if (expireTime < currentTime) {
			await this.renew()
		}
	}
}
